<template>
    <div class="holidays">
        <div class="leading">
            <button class="btn btn-primary" id="show-modal" @click="editHoliday()">Add Holiday</button>
        </div>
        <div class="table-responsive">
            <table class="table table-striped">
                <thead class="manager-list-heading">
                    <tr>
                        <th>Date</th>
                        <th>Name</th>
                        <th class="actions">Actions</th>
                    </tr>
                </thead>
                <holidays v-slot="{ holidays }">
                    <tbody class="manager-list-row">
                        <tr v-for="holiday in holidays" :key="holiday.id">
                            <td class="date" v-text="shortDate(holiday.date)"></td>
                            <td class="name" v-text="holiday.name"></td>
                            <td class="actions">
                                <button class="btn btn-primary btn-sm" @click="editHoliday(holiday.id)">Edit</button>
                            </td>
                        </tr>
                    </tbody>
                </holidays>
            </table>
        </div>
        <holiday-modal v-if="showModal" @close="showModal = false;" :id="modalHoliday"></holiday-modal>
    </div>
</template>

<script>
import HolidayModal from './HolidayModal';
import ModalWatcher from './ModalWatcher';
import moment from 'moment';
import { ContinuousCollectionComponent } from 'clockvine-vue';

export default {
    components: {
        HolidayModal,
        holidays: ContinuousCollectionComponent.for('holidays')
    },

    mixins: [
        ModalWatcher,
    ],

    data: () => ({
        showModal: false,
        modalHoliday: null,
    }),

    methods: {
        formatDate(date) {
            return moment(date).format('MMM D, YYYY');
        },
        editHoliday(id) {
            this.modalHoliday = id;
            this.showModal = true;
        },
        destroyHoliday(id) {
            this.modalHoliday = id;
        },
    },
}
</script>
